import { Injectable } from '@angular/core';
import { AppEnvironmentName } from '@share/constants';
import { environment } from '../../../environments/environment';
import { AppEnvironment } from '@share/model-objects/environment.model';
import { AppVersion } from '@share/model-objects/version.model';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  isDevOrStaging(): boolean {
    return (
      environment.envName === AppEnvironmentName.DEV ||
      environment.envName === AppEnvironmentName.STG
    );
  }

  getEnvironment(): AppEnvironment {
    return environment;
  }

  getLogoutUrl(): string {
    return environment.logoutUrl;
  }

  getVersion(): AppVersion {
    return environment.version;
  }

  getEosUrl(): string {
    return environment.eosUrl;
  }

  getDebugMode(): boolean {
    return environment.useDebugMode;
  }
}
